import {findClipById, findMarkerById} from '~/utils/video-editor/clip-utils.js';

export function useVideoEditorStoreSelection({clips}) {
  const activeEditClipId = ref(null);
  const activeEditMarkerId = ref(null);

  function setActiveEditClip({clipId}) {
    const selectedClip = findClipById({
      clipId,
      clips: clips.value
    });

    activeEditClipId.value = selectedClip?.id ?? null;
    activeEditMarkerId.value = null;
  }

  function setActiveEditMarker({markerId, clipId = null}) {
    const selection = findMarkerById({
      markerId,
      clipId,
      clips: clips.value
    });

    activeEditClipId.value = selection?.clip?.id ?? null;
    activeEditMarkerId.value = selection?.marker?.id ?? null;
  }

  function clearActiveEditClip() {
    activeEditClipId.value = null;
    activeEditMarkerId.value = null;
  }

  function clearActiveEditMarker() {
    activeEditMarkerId.value = null;
  }

  const selectedClip = computed(() => findClipById({
    clipId: activeEditClipId.value,
    clips: clips.value
  }));

  const selectedMarker = computed(() => findMarkerById({
    markerId: activeEditMarkerId.value,
    clipId: activeEditClipId.value,
    clips: clips.value
  })?.marker || null);

  const selectedMarkerClip = computed(() => findMarkerById({
    markerId: activeEditMarkerId.value,
    clipId: activeEditClipId.value,
    clips: clips.value
  })?.clip || null);

  return {
    activeEditClipId,
    activeEditMarkerId,

    setActiveEditClip,
    setActiveEditMarker,
    clearActiveEditClip,
    clearActiveEditMarker,

    selectedClip,
    selectedMarker,
    selectedMarkerClip
  };
}
